export const USER_TOP_NAV_SECTIONS = [
    {
        id: 'sales',
        label: '영업지원',
        visibilityKey: 'showSalesSupportMenu',
        audience: 'user-dropdown',
        groups: [{ itemIds: ['public-card', 'public-landing', 'org-homepage', 'category-landing-pages', 'consultations'] }],
    },
    {
        id: 'customer',
        label: '고객지원',
        visibilityKey: 'showCustomerSupportMenu',
        audience: 'user-dropdown',
        groups: [
            { itemIds: ['customer-work-queue', 'customers', 'maturity-ledger',  'customer-support-tools'] },
            {
                dividerBefore: true,
                dividerWhenAnyVisible: ['survey-management', 'sales-images', 'claims'],
                itemIds: ['survey-management', 'sales-images', 'claims'],
            },
        ],
    },
    {
        id: 'design',
        label: '설계지원',
        visibilityKey: 'showDesignSupportMenu',
        audience: 'user-dropdown',
        groups: [
            { itemIds: ['health-analysis', 'hidden-insurance-money', 'fire-building-registry', 'uw3nn-exceptions'] },
            { dividerBefore: true, dividerWhenAnyVisible: ['requests'], itemIds: ['requests'] },
        ],
    },
    {
        id: 'work',
        label: '업무지원',
        visibilityKey: 'showWorkSupportMenu',
        audience: 'user-dropdown',
        groups: [
            {
                itemIds: ['personal-counterparts', 'insurance-market-insights', 'insurer-newsletters', 'insurer-systems', 'insurer-business-hub', 'work-calendar', 'education-center', 'counsel-practice', 'work-support-tools'],
            },
        ],
    },
    {
        id: 'admin',
        label: '관리',
        visibilityKey: 'showAdminMenu',
        audience: 'user-dropdown',
        groups: [{ itemIds: ['notices', 'orgs', 'org-banners', 'users', 'org-dashboard', 'org-library'] }],
    },
]

export const OPERATOR_USER_MENU_SECTIONS = [
    { id: 'sales', label: '영업지원', sectionKey: 'sales', audience: 'operator-user-menu', groups: USER_TOP_NAV_SECTIONS[0].groups },
    { id: 'customer', label: '고객지원', sectionKey: 'customer', audience: 'operator-user-menu', groups: USER_TOP_NAV_SECTIONS[1].groups },
    { id: 'design', label: '설계지원', sectionKey: 'design', audience: 'operator-user-menu', groups: [
        { itemIds: ['health-analysis', 'hidden-insurance-money', 'fire-building-registry', 'uw3nn-exceptions', 'requests'] },
        {
            dividerBefore: true,
            dividerWhenAnyVisible: ['design-reference-hub', 'design-disease-rider', 'design-surgery-search', 'design-major-disease-n'],
            itemIds: ['design-reference-hub', 'design-disease-rider', 'design-surgery-search', 'design-major-disease-n'],
        },
    ] },
    { id: 'work', label: '업무지원', sectionKey: 'work', audience: 'operator-user-menu', groups: USER_TOP_NAV_SECTIONS[3].groups },
    {
        id: 'admin',
        label: '관리',
        sectionKey: 'admin',
        audience: 'operator-user-menu',
        groups: [{ itemIds: ['notices', 'orgs', 'org-banners', 'users', 'org-dashboard', 'org-library', 'signups', 'withdrawal-approvals', 'availability'] }],
    },
]

export const OPERATOR_SUBSCRIPTIONS_SECTION = {
    id: 'subscriptions',
    label: '과금/구독관리',
    visibilityKey: 'isOperator',
    itemIds: ['subscriptions-dashboard', 'subscriptions-statistics', 'subscriptions-config', 'subscriptions-orgs', 'subscriptions-hub'],
}

export const OPERATOR_DATA_SECTION = {
    id: 'data',
    label: '데이터관리',
    visibilityKey: 'showDataMgmtMenu',
    itemIds: ['exception-rules', 'insurers-master', 'permissions', 'raw-data-management', 'public-data-management', 'terms-management', 'design-support-reference-data', 'files'],
}

export const OPERATOR_OPS_GROUPS = [
    {
        title: '운영관리',
        itemIds: ['ops-usage-dashboard', 'ops-org-user-management', 'ops-operational-costs', 'ops-operational-stats', 'system-notices', 'support-inquiries', 'ops-history-management', 'ops-alimtalk-sender'],
    },
    {
        title: '서식관리',
        itemIds: ['ops-claim-templates', 'after-contract-certificates'],
    },
    {
        title: '템플릿관리',
        itemIds: ['policy-delivery-book-templates', 'coverage-rule-templates', 'report-output-templates', 'homepage-templates', 'survey-templates', 'message-templates', 'customer-memo-templates', 'ops-alimtalk-templates'],
    },
    {
        title: '기타관리',
        itemIds: ['ops-other-management', 'ops-counsel-practice-management', 'ops-customer-work-hub', 'ops-kakao-talk-management', 'ops-legal-policy-management', 'ops-support-guide-manuals', 'ops-operation-tests'],
    },
]
